import React, { useState, useEffect, Fragment } from 'react';
import {
    Row,
    Card,
    CardBody,
    Button,
    Input,
    Label,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
} from 'reactstrap';
import { Colxx, Separator } from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import Switch from 'rc-switch';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import 'rc-switch/assets/index.css';
import '../../style/style.css';
import { API_Ingetration } from '../../../../../../constants/APIs';
const quillModules = {
    toolbar: [
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [
            { list: 'ordered' },
            { list: 'bullet' },
            { indent: '-1' },
            { indent: '+1' },
        ],
        ['link', 'image'],
        ['clean'],
    ]
};

const quillFormats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'image',
];

export default function HelpCenterChatBot({ botSettings, saveIntegration, locale }) {
    const [activeTab, setActiveTab] = useState('chat');
    const [checkedPrimarySmall, setCheckedPrimarySmall] = useState(botSettings && botSettings.chatBot !== null && !botSettings.chatBot.botDisabled);
    const [checkedPrimarySmallCall, setCheckedPrimarySmallCall] = useState(false);
    const [integrationList, setIntegrationList] = useState([]);
    const [chatBotDetails, setChatBotDetails] = useState({ title: '', subTitle: '', contactInformation: '', locale: locale });
    const [callBotDetails, setCallBotDetails] = useState({ title: '', subTitle: '', desktopLink: '', mobileLink: '' });
    const [botInputData, setBotInputData] = useState({
        botDisabled: false,
        botIntegrationId: "",
        botIntegrationIcon: ""
    });
    const [callInputData, setCallInputData] = useState({
        botDisabled: false,
        botIntegrationId: "",
        botIntegrationIcon: "",
        desktopLink: "",
        mobileLink: "",
        copyDesktopToMobile: false
    });

    useEffect(() => {
        let body = {
            channels: ['WebsiteDirectLine']
        };
        AxiosAPI({
            method: 'post',
            url: `${API_Ingetration}?group_id=${getGroupID()}`,
            data: body
        }).then((res) => {
            const webIntegrationData = res.data.filter(
                (k) => k.channel === 'WebsiteDirectLine' && k.disabled === false
            );
            setIntegrationList(webIntegrationData);
        });
        if (botSettings !== undefined && botSettings.chatBot !== null) {
            var chatbot = botSettings.chatBot.chatBotDetails.filter(i => i.locale === locale);
            if (chatbot.length > 0) {
                setChatBotDetails({
                    title: chatbot[0].title,
                    subTitle: chatbot[0].subTitle,
                    contactInformation: chatbot[0].contactInformation,
                    locale: locale
                })
            } else {
                var chatbotEn = botSettings.chatBot.chatBotDetails.filter(i => i.locale === "en");
                if (chatbotEn.length > 0) {
                    setChatBotDetails({
                        title: chatbotEn[0].title,
                        subTitle: chatbotEn[0].subTitle,
                        contactInformation: chatbotEn[0].contactInformation,
                        locale: locale
                    });
                }
            }
            setBotInputData({
                ...botSettings.chatBot,
                botDisabled: botSettings.chatBot.botDisabled,
                botIntegrationIcon: botSettings.chatBot.botIntegrationIcon,
                botIntegrationId: botSettings.chatBot.botIntegrationId
            });
        }
        // initialize call bot if present (fall back to chatBot not defined)
        if (botSettings !== undefined) {
            const sourceCall = botSettings.chatBot || {};
            if (sourceCall.callBotDetails?.length > 0) {
                setCheckedPrimarySmallCall(sourceCall.callBotDetails?.[0]?.isEnable ?? false);
                setCallBotDetails({
                    title: sourceCall.callBotDetails[0].title,
                    subTitle: sourceCall.callBotDetails[0].subTitle,
                    desktopLink: sourceCall.callBotDetails[0].desktopLink,
                    mobileLink: sourceCall.callBotDetails[0].mobileLink,
                })
            } else if (sourceCall.callBotDetails) {
                var callbotEn = sourceCall.callBotDetails.filter(i => i.locale === "en");
                if (callbotEn.length > 0) {
                    setCallBotDetails({
                        title: callbotEn[0].title,
                        subTitle: callbotEn[0].subTitle,
                        desktopLink: callbotEn[0].desktopLink,
                        mobileLink: callbotEn[0].mobileLink,
                    });
                }
            }
            setCallInputData({
                ...sourceCall,
                botDisabled: !!sourceCall.botDisabled,
                botIntegrationIcon: sourceCall.botIntegrationIcon || sourceCall.botIntegrationIcon === '' ? sourceCall.botIntegrationIcon : '',
                botIntegrationId: sourceCall.botIntegrationId || '',
                desktopLink: sourceCall.desktopLink || '',
                mobileLink: sourceCall.mobileLink || '',
                copyDesktopToMobile: !!sourceCall.copyDesktopToMobile
            });
        }
    }, [botSettings]);

    const handleSave = (e) => {
        let setting = botSettings || {};
        if (activeTab === 'chat') {
            var existingDetail = (setting.chatBot && setting.chatBot.chatBotDetails) ? setting.chatBot.chatBotDetails.filter(i => i.locale !== locale) : [];
            var assitantdata = [...existingDetail, chatBotDetails];
            var chatbot = { ...(setting.chatBot || {}), ...botInputData, chatBotDetails: assitantdata };
            setting.chatBot = chatbot;
        } else {
            var existingDetail = [];
            var assitantdata = [callBotDetails];
            var callBot = { ...(setting.chatBot || {}), ...callInputData, callBotDetails: assitantdata };
            setting.chatBot = callBot;
        }
        saveIntegration({
            botSetting: setting
        });
    };

    const handleTextChange = (e) => {
        setChatBotDetails({ ...chatBotDetails, [e.target.name]: e.target.value });
    }
    const handleTextChangeCall = (e) => {
        setCallBotDetails({ ...callBotDetails, [e.target.name]: e.target.value });
    }
    const handleChange = (e) => {
        var integration = integrationList.filter(i => i.id === e.target.value).map(k => k.botSettings !== null && k.botSettings.urls && k.botSettings.urls.icon);
        const iconUrl = integration.length > 0 ? integration[0] : "";
        setBotInputData({ ...botInputData, botIntegrationId: e.target.value, botIntegrationIcon: iconUrl });
    };

    const handleChangeCall = (e) => {
        var integration = integrationList.filter(i => i.id === e.target.value).map(k => k.botSettings !== null && k.botSettings.urls && k.botSettings.urls.icon);
        const iconUrl = integration.length > 0 ? integration[0] : "";
        setCallInputData({ ...callInputData, botIntegrationId: e.target.value, botIntegrationIcon: iconUrl });
    };

    const handleDesktopLinkChange = (e) => {
        const val = e.target.value;
        setCallBotDetails({ ...callBotDetails, desktopLink: val });
    };
    const handleMobileLinkChange = (e) => {
        setCallBotDetails({ ...callBotDetails, mobileLink: e.target.value });
    };

    const handleChangeContact = (source, data) => {
        if (source === 'user') {
            setChatBotDetails({ ...chatBotDetails, contactInformation: data });
        }
    };
    const handleSwitchChange = (value) => {
        setCheckedPrimarySmall(value);
        setBotInputData({
            ...botInputData,
            botDisabled: !value
        });
    };
    const handleSwitchChangeCall = (value) => {
        setCheckedPrimarySmallCall(value);
        setCallBotDetails({
            ...callBotDetails,
            isEnable: value
        });
    };
    return (
        <Fragment>
            <Card className="mb-4">
                <CardBody>
                    <h6 className="text-center">Add Chatbot or Contact Info </h6>
                    <Separator className="mb-3" />
                    <Nav tabs className="card-header-tabs separator-tabs ml-1 mb-3">
                        <NavItem>
                            <span className={'nav-link ' + (activeTab === 'chat' ? 'active' : '')} onClick={() => setActiveTab('chat')}>Chat</span>
                        </NavItem>
                        <NavItem>
                            <span className={'nav-link ' + (activeTab === 'call' ? 'active' : '')} onClick={() => setActiveTab('call')}>Call</span>
                        </NavItem>
                    </Nav>
                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="chat">
                            <Card className="m-4 p-4">
                                <Colxx md={12} className="mb-3 px-0">
                                    <div className="d-flex w-100">
                                        <h6>Enable Chatbot</h6>
                                        <Switch
                                            className="agentswitch custom-switch-primary custom-switch-small ml-2"
                                            checked={checkedPrimarySmall}
                                            onChange={(primary) => handleSwitchChange(primary)}
                                        />
                                    </div>
                                </Colxx>
                                <Colxx md={12} className="mb-3 px-0">
                                    <b className='mb-1'>Title</b>
                                    <Input
                                        type="text"
                                        name="title"
                                        placeholder="Title"
                                        value={chatBotDetails.title}
                                        onChange={(e) => handleTextChange(e)}
                                    ></Input>
                                </Colxx>
                                <Colxx md={12} className="mb-3 px-0">
                                    <b className='mb-1'>Sub Title</b>
                                    <Input
                                        type="text"
                                        name="subTitle"
                                        placeholder="Sub Title"
                                        value={chatBotDetails.subTitle}
                                        onChange={(e) => handleTextChange(e)}
                                    ></Input>
                                </Colxx>
                                <Colxx md={12} className="mb-1 px-0">
                                    <b className='mb-1'>Select Chatbot to Integrate</b>
                                    <Input
                                        type="select"
                                        className="dropdown-menu dropdowntimezone"
                                        name="botIntegtrationId"
                                        value={botInputData.botIntegrationId}
                                        onChange={(e) => handleChange(e)}
                                    >
                                        <option value={""}>Select Integration</option>
                                        {integrationList.map((item, i) => (
                                            <option value={item.id} key={i}>
                                                {item.name === null || item.name === "" ? item.botSettings.name : item.name + " - " + item.botSettings.name}
                                            </option>
                                        ))}
                                    </Input>
                                </Colxx>
                                {botInputData.botDisabled === true && (
                                    <Colxx md={12} className="mt-2 mb-1 px-0">
                                        <b className='mb-1'>Contact Information</b>
                                        <ReactQuill
                                            theme="snow"
                                            value={chatBotDetails.contactInformation}
                                            onChange={(content, delta, source) =>
                                                handleChangeContact(source, content)
                                            }
                                            modules={quillModules}
                                            formats={quillFormats}
                                            name="contactInformation"
                                        />
                                    </Colxx>
                                )}
                            </Card>
                        </TabPane>
                        <TabPane tabId="call">
                            <Card className="m-4 p-4">
                                <Colxx md={12} className="mb-3 px-0">
                                    <div className="d-flex w-100">
                                        <h6>Enable Call</h6>
                                        <Switch
                                            className="agentswitch custom-switch-primary custom-switch-small ml-2"
                                            checked={checkedPrimarySmallCall}
                                            onChange={(primary) => handleSwitchChangeCall(primary)}
                                        />
                                    </div>
                                </Colxx>
                                <Colxx md={12} className="mb-3 px-0">
                                    <b className='mb-1'>Title</b>
                                    <Input
                                        type="text"
                                        name="title"
                                        placeholder="Title"
                                        value={callBotDetails.title}
                                        onChange={(e) => handleTextChangeCall(e)}
                                    ></Input>
                                </Colxx>
                                <Colxx md={12} className="mb-3 px-0">
                                    <b className='mb-1'>Sub Title</b>
                                    <Input
                                        type="text"
                                        name="subTitle"
                                        placeholder="Sub Title"
                                        value={callBotDetails.subTitle}
                                        onChange={(e) => handleTextChangeCall(e)}
                                        maxLength={35}
                                    />
                                </Colxx>
                                <Colxx md={12} className="mb-3 px-0">
                                    <b className='mb-1'>Desktop Link</b>
                                    <Input
                                        type="text"
                                        name="desktopLink"
                                        placeholder="Desktop link"
                                        value={callBotDetails.desktopLink}
                                        onChange={(e) => handleDesktopLinkChange(e)}
                                    />
                                </Colxx>
                                <Colxx md={12} className="mb-3 px-0">
                                    <b className='mb-1'>Mobile Link</b>
                                    <Input
                                        type="text"
                                        name="mobileLink"
                                        placeholder="Mobile link"
                                        value={callBotDetails.mobileLink}
                                        onChange={(e) => handleMobileLinkChange(e)}
                                    />
                                </Colxx>
                            </Card>
                        </TabPane>
                    </TabContent>
                    <Separator className="mb-3" />
                    <Colxx md={12} className="text-center">
                        <Button
                            color="primary"
                            size="xs"
                            className="my-2"
                            onClick={handleSave}
                        >
                            Save
                        </Button>
                    </Colxx>
                </CardBody>
            </Card>
        </Fragment>
    );
}
